import { AUTO_REFRESH_INTERVAL_MS } from '@/constants'
import { useInterval } from '@mantine/hooks'
import { useCallback, useEffect, useRef } from 'react'

const useAutoRefresh = () => {
  const previousEtag = useRef<string>()

  const refresh = useCallback(async () => {
    const url = new URL(window.location.href)
    url.pathname = ''

    const response = await fetch(url.toString(), {
      headers: [
        ['pragma', 'no-cache'],
        ['cache-control', 'no-cache'],
      ],
    })

    const etag = response.headers.get('etag')

    if (etag) {
      if (previousEtag.current !== undefined && previousEtag.current !== etag) {
        window.location.reload()
      }
      previousEtag.current = etag
    }
  }, [])

  const interval = useInterval(refresh, AUTO_REFRESH_INTERVAL_MS)

  useEffect(() => {
    refresh().then(interval.start)
    return interval.stop
    // mount-only: interval is a stable @mantine/hooks ref and refresh is memoized
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

export default useAutoRefresh
